import React from 'react';

const LoaderProgress = ({ progress }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)', // zatamnjena pozadina
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '120px',
          height: '120px',
        }}
      >
        {/* Spinner krug */}
        <div
          style={{
            width: '100%',
            height: '100%',
            border: '8px solid #f3f3f3',
            borderTop: '8px solid #ff7c00',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />

        {/* Tekst u sredini */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '57%',
            transform: 'translate(-50%, -50%)',
            fontWeight: 'bold',
            fontSize: '20px',
            color: '#ff7c00',
          }}
        >
          {progress}%
        </div>
      </div>

      {/* Animacija */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoaderProgress;
